module.exports = __webpack_public_path__ + "img/logo_white.97d82e26.svg";